import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar } from 'recharts';
import './Applicants.css';

const Dash = () => {
  const [Students, setStudents] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [courseData, setCourseData] = useState([]);
     const [metrics, setMetrics] = useState({
     totalCourses: 0,
     totalRegistered: 0,
     totalStudents: 0,
     totalApplicants: 0,
     totalAccepted: 0,
     totalPending: 0,
     totalRejected: 0,
   });

  const getChartMetrics = (data) => {
    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const groupedData = data.reduce((acc, item) => {
      const date = formatDate(item.CreationDate);
      const status = item.ReviewStatus;
      const course = item.CourseName;

      if (!acc[date]) {
        acc[date] = { date, Pending: 0, Rejected: 0, Registered: 0, Accepted: 0 };
      }
      acc[date][status] += 1;

      return acc;
    }, {});

    const chartData = Object.values(groupedData);
   // setStudents(chartData);
   //   Calculate metrics
    const totalApplicants = data.length;
    const totalAccepted = data.filter(item => item.ReviewStatus === 'Accepted').length;
    const totalPending = data.filter(item => item.ReviewStatus === 'Pending').length;
    const totalRejected = data.filter(item => item.ReviewStatus === 'Rejected').length;
    const totalRegistered = data.filter(item => item.Status === 'Registered').length;

    setStudents(chartData);
    setMetrics({
      totalCourses: 12, // Replace with actual calculation if available
      totalStudents: 12, // Replace with actual calculation if available
      totalApplicants,
      totalAccepted,
      totalPending,
      totalRejected,
      totalRegistered
    });


    const statusCounts = data.reduce((acc, item) => {
      acc[item.ReviewStatus] = (acc[item.ReviewStatus] || 0) + 1;
      return acc;
    }, {});

    const statusArray = Object.keys(statusCounts).map((key) => ({
      name: key,
      value: statusCounts[key],
    }));

    setStatusData(statusArray);

    const courseCounts = data.reduce((acc, item) => {
      acc[item.CourseName] = (acc[item.CourseName] || 0) + 1;
      return acc;
    }, {});

    const courseArray = Object.keys(courseCounts).map((key) => ({
      name: key,
      count: courseCounts[key],
    }));

    setCourseData(courseArray);
  };

  useEffect(() => {
    async function getCourses() {
      try {
        const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
        if (response) {
          getChartMetrics(response.data);
        } else {
          console.log('pull fail');
        }
      } catch (e) {
        console.log('catch error', e);
      }
    }
    getCourses();
  }, []);

  return (
    <div className="dashContainer">
             <div className='ScorecardsContainer'>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Courses</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalCourses}</h1>
           </div>
         </div>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Registered</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalRegistered}</h1>
           </div>
         </div>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Applicants</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalApplicants}</h1>
           </div>
         </div>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Accepted</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalAccepted}</h1>
           </div>
         </div>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Pending</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalPending}</h1>
           </div>
         </div>
         <div className='scorecard'>
           <div className='scorecardheader'>
             <h4>Rejected</h4>
           </div>
           <div className='scorecardvalue'>
             <h1>{metrics.totalRejected}</h1>
           </div>
         </div>
       </div>

      <div className="chartWrapper">
          <h4>Applicants VS Registration Graph</h4>
          <ResponsiveContainer className="overflower" width="100%" height={300}>
            <LineChart data={Students}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="Pending" stroke="#8884d8" />
              <Line type="monotone" dataKey="Accepted" stroke="#82ca9d" />
              <Line type="monotone" dataKey="Rejected" stroke="red" />
              <Line type="monotone" dataKey="Registered" stroke="green" />
            </LineChart>
          </ResponsiveContainer>
        </div>

      <div className="ChartsContainer">
       

        <div className="chartWrapper">
          <h4>Status Distribution</h4>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={statusData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} fill="#8884d8" label>
                {statusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={["#8884d8", "#82ca9d", "red", "green"][index % 4]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chartWrapper">
          <h4>Courses and Applicants</h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={courseData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="count" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Dash;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import './Applicants.css';

// const Dash = () => {
//   const [Students, setStudents] = useState([]);
//   const [metrics, setMetrics] = useState({
//     totalCourses: 0,
//     totalStudents: 0,
//     totalApplicants: 0,
//     totalAccepted: 0,
//     totalPending: 0,
//     totalRejected: 0,
//   });

//   const getChartMetrics = (data) => {
//     const formatDate = (dateString) => {
//       const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
//       return new Date(dateString).toLocaleDateString(undefined, options);
//     };

//     const groupedData = data.reduce((acc, item) => {
//       const date = formatDate(item.CreationDate);
//       const status = item.ReviewStatus;

//       if (!acc[date]) {
//         acc[date] = { date, Pending: 0, Rejected: 0, Registered: 0, Accepted: 0 };
//       }

//       acc[date][status] += 1;

//       return acc;
//     }, {});

//     const chartData = Object.values(groupedData);

//     // Calculate metrics
//     const totalApplicants = data.length;
//     const totalAccepted = data.filter(item => item.ReviewStatus === 'Accepted').length;
//     const totalPending = data.filter(item => item.ReviewStatus === 'Pending').length;
//     const totalRejected = data.filter(item => item.ReviewStatus === 'Rejected').length;

//     setStudents(chartData);
//     setMetrics({
//       totalCourses: 12, // Replace with actual calculation if available
//       totalStudents: 12, // Replace with actual calculation if available
//       totalApplicants,
//       totalAccepted,
//       totalPending,
//       totalRejected,
//     });

//     console.log("chart data", chartData);
//   };

//   useEffect(() => {
//     async function getCourses() {
//       try {
//         const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
//         if (response) {
//           console.log('DASH students', response);
//           getChartMetrics(response.data);
//         } else {
//           console.log('pull fail');
//         }
//       } catch (e) {
//         console.log('catch error', e);
//       }
//     }
//     getCourses();
//   }, []);

//   return (
//     <div className='dashContainer'>
//       <div className='ScorecardsContainer'>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Courses</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalCourses}</h1>
//           </div>
//         </div>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Students</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalStudents}</h1>
//           </div>
//         </div>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Applicants</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalApplicants}</h1>
//           </div>
//         </div>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Accepted</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalAccepted}</h1>
//           </div>
//         </div>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Pending</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalPending}</h1>
//           </div>
//         </div>
//         <div className='scorecard'>
//           <div className='scorecardheader'>
//             <h4>Rejected</h4>
//           </div>
//           <div className='scorecardvalue'>
//             <h1>{metrics.totalRejected}</h1>
//           </div>
//         </div>
//       </div>
//       <div className='SecondChartContainer'>
//         <div className='firstname'>
//           <div className='tagheading'>
//             <h4>Applicants VS Status Graph</h4>
//           </div>
//           <div className='chartOne'>
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart
//                 width={500}
//                 height={300}
//                 data={Students}
//                 margin={{
//                   top: 5,
//                   right: 30,
//                   left: 20,
//                   bottom: 5,
//                 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="date" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="Pending" stroke="#8884d8" activeDot={{ r: 8 }} />
//                 <Line type="monotone" dataKey="Accepted" stroke="#82ca9d" />
//                 <Line type="monotone" dataKey="Rejected" stroke="red" />
//                 <Line type="monotone" dataKey="Registered" stroke="green" />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dash;

// import React, { useState,useEffect } from 'react';
// import axios from 'axios';

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import './Applicants.css';

// const Dash = () => {

//   const [Students,setStudents] = useState()
//   const [chartData,setchartData] = useState()

//   const getChartMetrics  = (data) =>{
//   // Helper function to format the date
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };
  
//   // Grouping logic
//   const groupedData = data.reduce((acc, item) => {
//     const date = formatDate(item.CreationDate);
//     const status = item.ReviewStatus;
  
//     if (!acc[date]) {
//         acc[date] = { date, Pending: 0, Rejected: 0, Registered : 0 , Accepted : 0};
//     }
  
//     acc[date][status] += 1;
  
//     return acc;
//   }, {});


//   // Convert groupedData object to an array
//     const chartData = Object.values(groupedData);
//     setStudents(chartData);

//     console.log("chart data",chartData);
        

//   }



//   useEffect(() => {
//     async function getCourses() {
//       try {
//         const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
//         if (response) {
//           console.log('DASH students',response);
          
//           getChartMetrics(response.data)
//         } else {
//           console.log('pull fail');
//         }
//       } catch (e) {
//         console.log('catch error', e);
//       }
//     }
//     getCourses();
//   }, []);





//   const data = [
//     {
//       name: 'Page A',
//       uv: 4000,
//       pv: 2400,
//       amt: 2400,
//     },
//     {
//       name: 'Page B',
//       uv: 3000,
//       pv: 1398,
//       amt: 2210,
//     },
//     {
//       name: 'Page C',
//       uv: 2000,
//       pv: 9800,
//       amt: 2290,
//     },
//     {
//       name: 'Page D',
//       uv: 2780,
//       pv: 3908,
//       amt: 2000,
//     },
//     {
//       name: 'Page E',
//       uv: 1890,
//       pv: 4800,
//       amt: 2181,
//     },
//     {
//       name: 'Page F',
//       uv: 2390,
//       pv: 3800,
//       amt: 2500,
//     },
//     {
//       name: 'Page G',
//       uv: 3490,
//       pv: 4300,
//       amt: 2100,
//     },
//   ];

//   return (
//     <div className='dashContainer'>

//             <div className='ScorecardsContainer'> 
              
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Courses</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Students</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Applicants</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Accepted</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Pending</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>
//                           <div className='scorecard'> 
//                                 <div className='scorecardheader'>
//                                         <h4>Rejected</h4>
//                                 </div>
//                                 <div className='scorecardvalue'>
//                                       <h1>12</h1>
//                                 </div>

//                           </div>

//             </div>
//             <div className='SecondChartContainer'>  
//                   <div className='firstname'> 
//                           <div className='tagheading'>
//                                 <h4>Applicants VS Registration Graph</h4>
//                           </div>
//                           <div className='chartOne'>  
//                           <ResponsiveContainer width="100%" height="100%">
//                           <LineChart
//                             width={500}
//                             height={300}
//                             data={Students}
//                             margin={{
//                               top: 5,
//                               right: 30,
//                               left: 20,
//                               bottom: 5,
//                             }}
//                           >
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="date" />
//                             <YAxis />
//                             <Tooltip />
//                             <Legend />
//                             <Line type="monotone" dataKey="Pending" stroke="#8884d8" activeDot={{ r: 8 }} />
//                             <Line type="monotone" dataKey="Accepted" stroke="#82ca9d" />
//                             <Line type="monotone" dataKey="Rejected" stroke="red" />
//                             <Line type="monotone" dataKey="Registered" stroke="green" />
//                           </LineChart>
//                         </ResponsiveContainer>

//                           </div>

//                   </div>
//                   {/* <div className='lastname'>  
//                           <div className='tagheading'>  

//                                    <h4>Applicants VS Registration Graph</h4>

//                             </div>

//                   </div> */}

//             </div>
  
//     </div>
//   );
// };

//export default Dash;
